var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconHeartShield2(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#icon-heart-shield-2_svg__clip0_2952_65)",
    stroke: "#10c98f",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.558 9.808c1.122-3.506-.007-6.534-2.095-7.815-2.682-1.645-5.023-.982-6.429.074-.576.433-.864.65-1.034.65-.17 0-.458-.217-1.034-.65C8.56 1.011 6.219.348 3.537 1.993.018 4.153-.778 11.274 7.34 17.283c1.327.982 2.084 1.543 3.12 1.682"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16 16.5l1.2 1 1.8-2",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.443 11c-2.046 1.121-3.323 1.554-5.442 1.6-.04 5.423 1.289 7.695 5.442 10.4 4.236-2.489 5.365-4.832 5.557-10.4-2.381-.075-3.601-.44-5.557-1.6z",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "icon-heart-shield-2_svg__clip0_2952_65"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h24v24H0z"
  })))));
}
export default SvgIconHeartShield2;